import React, { useCallback } from 'react';
import { getLocation, push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { AdminPanelName } from '../../../state/admin-panels';
import { Theme } from '@mint/ui';
import { getWipPage } from '../../../selectors/page';
import gql from 'graphql-tag';
import { loadPageRequest } from '../../../actions/page';
import { pushAdminPanel } from '../../../actions/admin-panels';
import qs from 'qs';
import styled from 'styled-components';
import { useQuery } from 'react-apollo';

const Wrapper = styled.div`
  background: black;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 2px;
  color: white;
  cursor: pointer;
  font-family: ${({ theme }: { theme: Theme }) =>
    theme.typography.control.fontFamily};
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.3px;
  right: 0;
  opacity: 0.3;
  padding: 2px 6px 1px;
  position: absolute;
  top: 0;
  transition: opacity 620ms 500ms, transform 220ms;
  z-index: 1;
  white-space: nowrap;

  :hover {
    opacity: 0.8;
    transition: opacity 320ms, transform 220ms;
  }

  :active {
    opacity: 1;
    transition: opacity 20ms, transform 220ms;
  }
`;

const GET_PAGE_BY_PATH = gql`
  query GetPageByPath($path: String!) {
    page(path: $path) {
      id
    }
  }
`;

const createPushUrl = (id: string) => {
  const q = qs.stringify(
    {
      edit: 'true',
      pageId: id,
    },
    {
      addQueryPrefix: true,
    },
  );
  return `/admin/page${q}`;
};

export const AdminSiteViewportEditButton: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const wipPage = useSelector(getWipPage);
  const location = useSelector(getLocation as any) as any;

  const { data } = useQuery(GET_PAGE_BY_PATH, {
    variables: { path: location && location.pathname },
  });

  const onClick = useCallback(async () => {
    if (data && data.page && data.page.id) {
      dispatch(loadPageRequest(data.page.id));
      dispatch(
        pushAdminPanel(AdminPanelName.Page, {
          pageKey: data.page.id,
        }),
      );
      dispatch(push(createPushUrl(data.page.id)));
    }
  }, [data, wipPage]);

  return wipPage ? null : <Wrapper onClick={onClick}>Edit Page</Wrapper>;
};
